import React, { useEffect, useState } from 'react';
import { api } from '../../api.js';

export default function Marketplace() {
  const [posts, setPosts] = useState(null);

  useEffect(() => {
    api('/marketplace/posts').then(setPosts).catch(() => setPosts([]));
  }, []);

  return (
    <div>
      <h1>Marketplace</h1>
      {posts && posts.length === 0 && <p className="empty">No open loads posted right now.</p>}
      {posts && posts.length > 0 && (
        <table>
          <thead><tr><th>Route</th><th>Rate</th><th>Posted by</th></tr></thead>
          <tbody>
            {posts.map(p => (
              <tr key={p.id}><td>{p.origin} → {p.destination}</td><td>${p.rate_offered}</td><td>{p.posted_by_company}</td></tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}
